import { useState, useLayoutEffect, MutableRefObject } from 'react'

export default function useIsHorizontalOverflow<T extends HTMLElement>(
  ref: MutableRefObject<T | null>,
  deps: any[] = []
) {
  const [isOverflow, setIsOverflow] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current

    if (!element) {
      return
    }

    const trigger = (target: HTMLElement = element) => {
      const hasOverflow = target.scrollWidth > target.clientWidth
      setIsOverflow(hasOverflow)
    }

    let resizeObserver: ResizeObserver | undefined

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver((entries) => {
        const target = entries[0]?.target
        if (target instanceof HTMLElement) {
          trigger(target)
        }
      })
      resizeObserver.observe(element)
    }

    trigger(element)

    return () => {
      resizeObserver?.disconnect()
    }
  }, [ref, ...deps])

  return isOverflow
}
